export default __webpack_public_path__ + "static/media/about2.8b2b9661.jpg";